import React, { useEffect, useState } from "react";
import { BiPlus } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";

const ContractESP = ({ selectDatas, SET_FINAL_BODY }) => {
  const rate_category_id = getIdByName(
    selectDatas?.rate_category,
    "Employee Salary Package"
  );
  const [totMonthlyCharges, setTotalMonthlyCharges] = useState([0]);
  const [fixedColumns, setFixedColumns] = useState([
    {
      col: "job_position_id",
      title: "ACTUAL PROFESSION",
      type: "select",
      data: selectDatas?.job_possition,
      default: true,
    },
    {
      col: "visa_profession_id",
      title: "VISA PROFESSION",
      type: "select",
      data: selectDatas?.visa_profession,
      default: true,
    },
    {
      col: "profession_level_id",
      title: "PROFESSION LEVEL",
      type: "select",
      data: selectDatas?.profession_level,
      default: true,
    },
    {
      col: "gender",
      title: "GENDER",
      type: "select",
      data: [
        {
          id: "MALE",
          name: "MALE",
        },
        {
          id: "FEMALE",
          name: "FEMALE",
        },
      ],
      default: true,
    },
    {
      col: "nationality_id",
      title: "NATIONALITY",
      type: "select",
      data: selectDatas?.nationality,
      default: true,
    },
    {
      col: "quantity",
      title: "QUANTITY",
      default: true,
    },
  ]);

  const [fixedColsRows, setFixedColsRows] = useState([
    {
      job_position_id: "",
      visa_profession_id: "",
      profession_level_id: "",
      gender: "",
      nationality_id: "",
      quantity: "0",
    },
  ]);

  const [costSheetHeadings, setCostSheetHeadings] = useState([]);

  const [costSheetRows, setCostSheetRows] = useState([]);
  const [allRows, setAllRows] = useState([
    {
      id: 1,
      job_position_id: "",
      visa_profession_id: "",
      profession_level_id: "",
      gender: "",
      nationality_id: "",
      quantity: "",
      sections: [
        {
          rate_category_id: 1,
          columns: [],
        },
      ],
    },
  ]);

  useEffect(() => {
    const BASIC = selectDatas?.contract_cost_sheet_profession_basic_information || {};
    const data = selectDatas;
    const groupedResult = {};
    const headings = [];

    data?.contract_cost_sheet_headings?.forEach((heading) => {
      const rateCategoryId = heading?.rate_category_id;
      let rateCategoryItemName = heading?.rate_category_item_name;

      if (rateCategoryItemName === null) {
        const rateCategoryItem = data?.rate_category_item?.find(
          (item) => item?.id === heading?.rate_category_item_id
        );

        if (rateCategoryItem) {
          rateCategoryItemName = rateCategoryItem?.name;
        }
      }

      const resultItem = {
        id: heading?.id,
        rate_category_id: heading?.rate_category_id,
        rate_category_item_id: heading?.rate_category_item_id,
        rate_category_item_name: rateCategoryItemName,
        type: heading?.type,
        cost: "", // Initialize cost (fetch it separately)
        title: rateCategoryItemName,
      };

      headings.push(resultItem);

    });

    let reOrderedheadings = JSON.parse(JSON.stringify(headings))
    const salaryIndex = reOrderedheadings.findIndex(item => item.rate_category_item_name?.toUpperCase() === 'SALARY');
    const monthlyFeeIndex = reOrderedheadings.findIndex(item => item.rate_category_item_name?.toUpperCase() === 'MONTHLY FEE (EACH) (INCLUDING NITAKAT, ADMIN AND SL SERVICE FEE) (SAR)');

    if (salaryIndex !== -1) {
        const salaryItem = reOrderedheadings.splice(salaryIndex, 1);
        reOrderedheadings.unshift(salaryItem[0]);
    }
    
    if (monthlyFeeIndex !== -1) {
        const monthlyFeeItem = reOrderedheadings.splice(monthlyFeeIndex, 1);
        reOrderedheadings.splice(1, 0, monthlyFeeItem[0]);
    }

    setCostSheetHeadings(reOrderedheadings);
    
    const resultArray = [
      reOrderedheadings.map((item) => ({
        rate_category_id: item.rate_category_id,
        rate_category_item_name: item.rate_category_item_name,
        type: item.type,
        cost: "0", // Set the cost to "0" for each item
      })),
    ];

    
    setCostSheetRows(resultArray);

    const EmployeeSalaryPackage = groupedResult[1];
    console.log('roe',reOrderedheadings)

    setAllRows([
      {
        id: BASIC?.id,
        job_position_id: BASIC?.job_position_id,
        visa_profession_id: BASIC?.visa_profession_id,
        profession_level_id: BASIC?.profession_level_id,
        gender: BASIC?.gender,
        nationality_id: BASIC?.nationality_id,
        quantity: BASIC?.quantity,
        costSheet: EmployeeSalaryPackage,
      },
    ]);
    // setCostSheetDefault(selectDatas);
  }, [selectDatas]);

  // Row works
  const addNewRow = () => {
    setFixedColsRows([
      ...fixedColsRows,
      {
        job_position_id: "",
        visa_profession_id: "",
        profession_level_id: "",
        gender: "",
        nationality_id: "",
        quantity: "0",
      },
    ]);
    const newRow = JSON.parse(JSON.stringify(costSheetRows[0]));
    const tempRows = costSheetRows;
    for (let i = 0; i < newRow.length; i++) {
      newRow[i].cost = 0;
    }
    tempRows.push(newRow);
    setCostSheetRows([...tempRows]);
  };

  const deleteRow = (rowIndex) => {
    if (fixedColsRows.length <= 1) return false;
    const updatedRows = fixedColsRows.filter((ele, index) => {
      return index != rowIndex;
    });
    setFixedColsRows([...updatedRows]);

    const updatedCostRows = costSheetRows.filter((ele, index) => {
      return index != rowIndex;
    });
    setCostSheetRows([...updatedCostRows]);
  };

  function updateTotalMonthly(rowIndex, costSheet) {
    const updatedCosts = [...costSheet];
    let sum = 0;
    for (let i = 0; i < updatedCosts[rowIndex].length; i++) {
      const cost = parseInt(updatedCosts[rowIndex][i].cost);
      if (!isNaN(cost)) {
        sum += cost;
      }
    }
    const tot = sum + parseInt((updatedCosts[rowIndex][0].cost / 100) * 2);
    const totalUpdate = [...totMonthlyCharges];
    totalUpdate[rowIndex] = tot;
    setTotalMonthlyCharges([...totalUpdate]);
  }

  const handleUpdateRowProperties = (rowId, col, value, inputValue) => {
    if (!inputValue) {
      const tempRows = fixedColsRows;
      tempRows[rowId][col] = value;
      setFixedColsRows([...tempRows]);
    } else {
      const tempRows = fixedColsRows;
      tempRows[rowId][col] = value;
      setFixedColsRows([...tempRows]);
    }
    if (col === "profession_level_id") {
      const monthlyFee = getMonthlyFee(
        selectDatas,
        fixedColsRows[rowId]?.profession_level_id
      );
      const updatedCosts = [...costSheetRows];
      updatedCosts[rowId][1] = {
        ...updatedCosts[rowId][1],
        cost: parseInt(monthlyFee),
      };
      setCostSheetRows(updatedCosts);

      updateTotalMonthly(rowId, updatedCosts);
    }
  };

  const updateCostSheetValues = (rowIndex, costIndex, value) => {
    const updatedCostSheetRows = JSON.parse(JSON.stringify(costSheetRows));
    updatedCostSheetRows[rowIndex][costIndex].cost = value;
    setCostSheetRows(updatedCostSheetRows);
    updateTotalMonthly(rowIndex, updatedCostSheetRows);
  };

  const formatFinalData = () => {
    let finalRows = fixedColsRows;
    for (let i = 0; i < finalRows.length; i++) {
      finalRows[i].cost_sheet_heading = costSheetRows[i];
    }
    const updatedCostSheetHeadings = costSheetHeadings.map((item) => {
      const {
        default: removedDefault,
        costSheetId: removed,
        ...newItem
      } = item;
      return newItem;
    });

    // Create a mapping of item names to IDs from array2
    const itemMapping = {};
    updatedCostSheetHeadings?.forEach((item) => {
      itemMapping[item.rate_category_item_name] = item.id;
    });

    // Create a new array with the desired format
    const newArray = [];
    finalRows?.forEach((item1) => {
      const newItem = {
        job_position_id: item1?.job_position_id,
        visa_profession_id: item1?.visa_profession_id,
        profession_level_id: item1?.profession_level_id,
        gender: item1?.gender,
        nationality_id: item1?.nationality_id,
        quantity: item1?.quantity,
        heading: [],
      };

      item1?.cost_sheet_heading?.forEach((heading) => {
        const headingId = itemMapping[heading?.rate_category_item_name];
        if (headingId) {
          newItem?.heading?.push({
            heading_id: headingId,
            cost: heading?.cost,
          });
        }
      });

      newArray.push(newItem);
    });

    const finalOutput = {
      cost_sheet: newArray,
    };

    SET_FINAL_BODY(finalOutput);
  };

  useEffect(() => {
    formatFinalData();
  }, [fixedColsRows, costSheetRows]);

  return (
    <div>
      <div className="font-semibold text-xl ">EMPLOYEE SALARY PACKAGE</div>
      <div className="flex flex-col gap-1 overflow-x-scroll pt-10 pl-20 relative -left-16 pb-5">
        <div className="flex gap-1 w-full">
          <span
            style={{ minWidth: "5rem" }}
            className="w-20 flex items-center justify-center  bg-[#FED7AA] text-center break-words"
          >
            SNO
          </span>
          {fixedColumns?.map((item) => (
            <span
              key={item.col}
              style={{ minWidth: "14rem" }}
              className="w-56 flex items-center justify-center bg-[#FED7AA] break-words"
            >
              {item.title?.toUpperCase()}
            </span>
          ))}
          {costSheetHeadings?.map((item, index) => (
            <div
              key={index}
              style={{ minWidth: "14rem" }}
              className="w-60 min-w-56 bg-[#FED7AA] flex items-center text-center break-words relative"
            >
              <span className="text-center m-auto">
                {item?.rate_category_item_name?.toUpperCase()}
              </span>
            </div>
          ))}
          <span
            key={"total"}
            style={{ minWidth: "14rem" }}
            className="w-56 bg-[#FED7AA] text-center break-words"
          >
            TOTAL MONTHLY CHARGES (SAR)
          </span>
        </div>

        {/* Rows */}
        {fixedColsRows?.map((row, rowIndex) => {
          return (
            <div className="flex gap-1 w-full" key={rowIndex}>
              <span
                style={{ minWidth: "5rem" }}
                className="w-20 flex items-center justify-center  bg-[#E2E8F0] text-center break-words relative"
              >
                {rowIndex + 1}
                {rowIndex === fixedColsRows.length - 1 && (
                  <button
                    type="button"
                    className="p-1 rounded-md ring-1 ring-slate-300 absolute  -left-16"
                    onClick={addNewRow}
                  >
                    <BiPlus size={"1.2rem"} />
                  </button>
                )}
                <button
                  type="button"
                  className="bg-red text-white p-1 rounded-md ring-1 ring-red absolute -left-8"
                  onClick={() => deleteRow(rowIndex)}
                >
                  <MdDeleteOutline size={"1.2rem"} />
                </button>
              </span>
              {fixedColumns?.map((col, cid) => {
                return (
                  <React.Fragment key={cid}>
                    {col?.type === "select" ? (
                      <select
                        className={`bg-slate-200 select select-sm rounded-none focus:outline-none w-56`}
                        required
                        value={row[col.col]}
                        onChange={(e) =>
                          handleUpdateRowProperties(
                            rowIndex,
                            col.col,
                            e.target.value
                          )
                        }
                      >
                        <option value="" hidden>
                          SELECT AN OPTION
                        </option>
                        {col.data?.map((optionData) => (
                          <option value={optionData.id} key={optionData.id}>
                            {optionData.name?.toUpperCase()}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        defaultValue={row[col.col]}
                        onChange={(e) =>{
                          const val = col.col === 'quantity' ? e.target.value?.toUpperCase() : e.target.value;
                          handleUpdateRowProperties(
                            rowIndex,
                            col.col,
                            val,
                            true
                          )
                        }
                        }
                        type={`${col.col === "quantity" ? "text" : "number"}`}
                        required
                        placeholder="Enter Value"
                        style={{ minWidth: "14rem" }}
                        className="bg-[#E2E8F0] outline-none w-56 text-center "
                      />
                    )}
                  </React.Fragment>
                );
              })}
              {costSheetHeadings?.map((costSheet, costIndex) => {
                return (
                  // <React.Fragment key={costSheet?.rate_category_item_name}>
                  <React.Fragment key={costSheet.costSheetId}>
                    {costIndex === 1 ? (
                      <span
                        style={{ minWidth: "14rem" }}
                        className="w-56 flex items-center justify-center  bg-[#E2E8F0] text-center break-words relative"
                      >
                        {costSheetRows[rowIndex][costIndex].cost}
                      </span>
                    ) : (
                      <input
                        defaultValue={costSheetRows[rowIndex][costIndex]?.cost}
                        onChange={(e) =>
                          updateCostSheetValues(
                            rowIndex,
                            costIndex,
                            e.target.value
                          )
                        }
                        placeholder="Enter Values"
                        required
                        style={{ minWidth: "14rem" }}
                        type="number"
                        className="bg-[#E2E8F0] outline-none w-56 text-center "
                      />
                    )}
                  </React.Fragment>
                );
              })}
              <span
                style={{ minWidth: "14rem" }}
                className="w-56 flex items-center justify-center  bg-[#E2E8F0] text-center break-words relative"
              >
                {totMonthlyCharges[rowIndex]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ContractESP;

function getIdByName(arr, nameToFind) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].name === nameToFind) {
      return arr[i].id;
    }
  }
  return null;
}

function getMonthlyFee(selectDatas, profession_level_id) {
  if (profession_level_id && selectDatas) {
    const profession_level = selectDatas?.profession_level?.find(
      (item) => item.id == profession_level_id
    );
    const { admin_fee, nitakat, soundline_fee } = profession_level;
    return parseInt(admin_fee) + parseInt(nitakat) + parseInt(soundline_fee);
  } else {
    return 0;
  }
}
